var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M360.681,154.574C339.651,118.572,300.702,94.316,256,94.316s-83.651,24.257-104.681,60.258H360.681   z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M262.961,37.053c0,6.046-6.961,43.789-6.961,43.789s-6.961-37.743-6.961-43.789   s3.117-10.947,6.961-10.947C259.845,26.105,262.961,31.007,262.961,37.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M386.862,94.141c-4.275,4.275-35.886,26.041-35.886,26.041s21.766-31.611,26.041-35.886   c4.275-4.275,9.945-5.537,12.663-2.819C392.399,84.196,391.137,89.866,386.862,94.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M134.983,84.296c4.275,4.275,26.041,35.886,26.041,35.886s-31.611-21.766-35.886-26.041   c-4.275-4.275-5.537-9.945-2.819-12.663C125.038,78.759,130.708,80.021,134.983,84.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M194.274,47.946c2.314,5.586,10.326,43.12,10.326,43.12s-20.875-32.206-23.189-37.792   s-1.31-11.307,2.242-12.778S191.96,42.36,194.274,47.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M330.589,53.274C328.276,58.86,307.4,91.066,307.4,91.066s8.012-37.534,10.326-43.12   s7.069-8.921,10.621-7.45C331.899,41.967,332.903,47.688,330.589,53.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M227.419,39.223c1.202,5.925,1.882,44.299,1.882,44.299s-14.325-35.606-15.527-41.532   s0.878-11.348,4.646-12.113C222.189,29.114,226.218,33.298,227.419,39.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M360.195,70.544c-3.34,5.04-29.994,32.655-29.994,32.655s15.048-35.307,18.388-40.347   s8.646-7.403,11.85-5.279S363.535,65.504,360.195,70.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M111.386,110.963c5.04,3.34,32.655,29.994,32.655,29.994s-35.307-15.048-40.347-18.388   s-7.403-8.646-5.279-11.85C100.539,107.513,106.346,107.623,111.386,110.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M162.268,63.553c3.378,5.014,18.691,40.207,18.691,40.207s-26.861-27.414-30.238-32.429   c-3.378-5.014-3.531-10.821-0.343-12.969S158.89,58.538,162.268,63.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M407.605,121.425c-5.014,3.378-40.207,18.691-40.207,18.691s27.414-26.861,32.429-30.238   c5.014-3.378,10.821-3.531,12.969-0.343C414.944,112.724,412.62,118.048,407.605,121.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M296.922,41.678c-1.157,5.934-15.214,41.647-15.214,41.647s0.391-38.378,1.549-44.312   s5.154-10.148,8.928-9.413C295.959,30.336,298.08,35.744,296.922,41.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M301.071,42.709c-1.756,5.785-6.058,43.924-6.058,43.924s17.624-34.094,19.38-39.88   s0.197-11.381-3.482-12.497S302.827,36.924,301.071,42.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M165.93,61.348c2.849,5.333,26.775,35.342,26.775,35.342s-11.646-36.57-14.495-41.903   s-7.908-8.187-11.299-6.375C163.521,50.224,163.081,56.016,165.93,61.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M409.81,125.088c-5.333,2.849-35.342,26.775-35.342,26.775s36.57-11.646,41.903-14.495   c5.333-2.849,8.187-7.908,6.375-11.299C420.934,122.678,415.142,122.239,409.81,125.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M363.633,73.084c-3.836,4.673-22.405,38.262-22.405,38.262s29.33-24.754,33.166-29.427   s4.538-10.439,1.566-12.878C372.989,66.6,367.47,68.411,363.633,73.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M113.926,107.524c4.673,3.836,38.262,22.405,38.262,22.405s-24.754-29.33-29.427-33.166   c-4.673-3.836-10.439-4.538-12.878-1.566C107.443,98.169,109.253,103.688,113.926,107.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M231.647,38.588c0.592,6.017,11.212,42.898,11.212,42.898s3.235-38.243,2.644-44.26   s-4.173-10.59-7.999-10.214C233.678,27.388,231.055,32.571,231.647,38.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M266.777,37.243c-0.601,6.016,2.574,44.265,2.574,44.265s10.679-36.865,11.28-42.881   s-2.013-11.203-5.839-11.585C270.966,26.659,267.378,31.227,266.777,37.243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M137.815,81.732c3.829,4.679,33.12,29.48,33.12,29.48s-18.516-33.618-22.345-38.297   s-9.345-6.498-12.321-4.063S133.986,77.053,137.815,81.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M389.426,96.973c-4.679,3.829-29.48,33.12-29.48,33.12s33.618-18.516,38.297-22.345   s6.498-9.345,4.063-12.321C399.871,92.452,394.105,93.144,389.426,96.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M334.042,54.91c-2.858,5.328-14.561,41.88-14.561,41.88s23.973-29.972,26.831-35.3   s2.427-11.121-0.961-12.938C341.962,46.735,336.899,49.582,334.042,54.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M95.752,137.116c5.328,2.858,41.88,14.561,41.88,14.561s-29.972-23.973-35.3-26.831   s-11.121-2.427-12.938,0.961C87.578,129.195,90.424,134.259,95.752,137.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M197.871,46.662c1.747,5.788,19.318,39.91,19.318,39.91s-4.242-38.145-5.989-43.933   s-6.147-9.58-9.828-8.469C197.692,35.281,196.124,40.873,197.871,46.662z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/mw.635ea83bcde61c33cdfd771c9a285167.svg";
export { ForwardRef as ReactComponent };